import React from 'react';
import PropertyLocationSection from './PropertyLocationSection';
import PropertyDetailsCard from '../../../../components/propertyDetails/PropertyDetailsCard';

/**
 * PropertyTab
 *
 * Dedicated home for everything related to the physical property — keeps
 * the Overview tab focused on the customer relationship (Programs,
 * One-Time Jobs, Account Credit, Notes, etc.) and gives this surface room
 * to grow.
 *
 * Today:
 *   - PropertyLocationSection  (satellite map + Verify with Google)
 *   - PropertyDetailsCard      (gate codes, parking, pets, property notes)
 *
 * Future home for:
 *   - Property photo gallery
 *   - Property measurements (read-only mirror of Calculator-captured data)
 *   - Technician property notes
 *
 * Read-only viewer surface. The Calculator remains the only place where
 * measurements and drawing tools exist.
 */
const PropertyTab = ({ client }) => {
  return (
    <div className="space-y-4" data-testid="property-tab">
      <PropertyLocationSection client={client} />
      <PropertyDetailsCard
        leadOrClient={client}
        defaultOpen
      />
    </div>
  );
};

export default PropertyTab;
